module.exports = __webpack_public_path__ + "static/onmichannel-328e451ee41d9b3099cd263393575fcf.mp4";